import React from 'react';
import I18n from 'utils/I18n';
import PropTypes from 'prop-types';

import styles from './index.scss';
import ButtonWrapper, { LOG_IN, SIGN_UP } from '../ButtonWrapper';

const AppleButton = ({ type, onClick }) => {
  const I18nPrefix = 'strava.landing_page';

  return (
    <ButtonWrapper
      className={styles.appleButton}
      onClick={onClick}
      data-testid="apple_auth_btn"
    >
      {type === SIGN_UP
        ? I18n.t(`${I18nPrefix}.here_to_join.apple_cta_v2`)
        : 'implement_me'}
    </ButtonWrapper>
  );
};

AppleButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.oneOf([SIGN_UP, LOG_IN]).isRequired
};

AppleButton.defaultProps = {
  onClick: () => {}
};

export default AppleButton;
